import { useState, useEffect } from 'react';
 
export const useWindowDimensions = () => {
 
  const getWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window;
    // スマホ表示させるフラグ
    const verticalFlag = width < 650;
    // 縦長デバイス
    const verticalDevice = height > width*1.2;
    return {
      width,
      height,
      verticalFlag,
      verticalDevice,
    };
  }
 
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
  useEffect(() => {
    const onResize = () => {
      setWindowDimensions(getWindowDimensions());
    }
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  return windowDimensions;
}